/* istanbul ignore file */
import { FieldProps, useFieldHelper } from 'framework/ui/field';
import { EMPTY_VALUE_INDICATOR, NEW_TAB_LINK_PROPS, useAsyncValue } from 'framework/utils';
import { InputLoader } from 'framework/ui/mui-builder';
import { Link } from 'react-router-dom';
import useServiceCatalogService from '../useServiceCatalogService';
import { useServiceCatalogUrl } from '../route/route';

const ServiceCatalogLinkFieldWithNameLoading = ({ source, externalId, value, isOpenInNewTab }: FieldProps) => {
  const { getServiceSuggestions } = useServiceCatalogService();
  const { getSingleEntityUrl } = useServiceCatalogUrl();
  const { getValue: getId } = useFieldHelper({ source });
  const id = externalId || value || getId();

  const data = useAsyncValue(() => {
    if (id) {
      return getServiceSuggestions({ filter: { id: { eq: id } } });
    } else {
      return Promise.resolve({});
    }
  }, [id]);
  const service = data?.result?.[0] || null;

  const fieldValue =
    service === null ? (
      <InputLoader />
    ) : (
      <Link to={getSingleEntityUrl(id)} {...(isOpenInNewTab && NEW_TAB_LINK_PROPS)}>
        {service?.name || id}
      </Link>
    );

  return id ? fieldValue : EMPTY_VALUE_INDICATOR;
};

export default ServiceCatalogLinkFieldWithNameLoading;
